export default "__VITE_PUBLIC_ASSET__306bc331__"